import { defineComponent, computed, createElementBlock, createCommentVNode, openBlock, createElementVNode, normalizeClass, createVNode, withCtx, createTextVNode, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es112.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es83.js';
/* empty css                       */

const _hoisted_1 = {
  key: 0,
  class: "image-text-teaser"
};
const _hoisted_2 = { class: "image-text-teaser__header" };
const _hoisted_3 = { class: "image-text-teaser__headline" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 0,
  class: "image-text-teaser__button"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ImageTextTeaser",
  props: {
    teaser: { default: null },
    isImageStretched: { type: Boolean },
    isRounded: { type: Boolean, default: false }
  },
  setup(__props) {
    const hasButtonLink = computed(
      () => props.teaser?.buttonLink != null && props.teaser?.buttonText != null && props.teaser?.buttonText !== ""
    );
    const props = __props;
    const buttonStyleType = computed(() => {
      if (props.teaser?.buttonStyle) {
        return props.teaser?.buttonStyle;
      }
      return "primary";
    });
    return (_ctx, _cache) => {
      return props.teaser ? (openBlock(), createElementBlock("article", _hoisted_1, [
        createElementVNode("header", _hoisted_2, [
          props.teaser.image != null ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass([
              "image-text-teaser__image",
              {
                "image-text-teaser__image--not-stretched": !props.isImageStretched
              },
              { "image-text-teaser__image--is-rounded": props.isRounded }
            ])
          }, [
            createVNode(_sfc_main$1, {
              media: props.teaser.image,
              cols: [6, 6, 6],
              lazyload: true
            }, null, 8, ["media"])
          ], 2)) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_3, [
            createElementVNode("h3", {
              innerHTML: props.teaser.headline
            }, null, 8, _hoisted_4)
          ])
        ]),
        createElementVNode("div", {
          class: "image-text-teaser__text rte-text",
          innerHTML: props.teaser.text
        }, null, 8, _hoisted_5),
        hasButtonLink.value ? (openBlock(), createElementBlock("div", _hoisted_6, [
          createVNode(_sfc_main$2, {
            link: props.teaser?.buttonLink || "",
            "style-type": buttonStyleType.value
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(props.teaser.buttonText), 1)
            ]),
            _: 1
          }, 8, ["link", "style-type"])
        ])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
